import { render, staticRenderFns } from "./DT_Measurement.vue?vue&type=template&id=35fb3693&scoped=true&"
import script from "./DT_Measurement.vue?vue&type=script&lang=js&"
export * from "./DT_Measurement.vue?vue&type=script&lang=js&"
import style0 from "./DT_Measurement.vue?vue&type=style&index=0&id=35fb3693&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb3693",
  null
  
)

export default component.exports